/**
 * Which state the join card shows (design workspaces c):
 * - `mismatch` (c4): the invite is for another email.
 * - `full` (c6): the workspace has no seat for one more member.
 * - `alreadyMember` (c5): the caller already has a row; the page opens the workspace instead.
 * - `ready` (c1, c7): "Join workspace" works; a failed join shows its message.
 *
 * Only the preview gives `alreadyMember`. An `M24_TEAM_ALREADY_MEMBER` answer from `team.accept`
 * reloads the preview (`TeamAcceptFlow`), because only the preview holds the licence to open.
 */
export type TeamAcceptInviteState = 'mismatch' | 'full' | 'alreadyMember' | 'ready';

export function teamAcceptInviteState(
  preview: { emailMatches: boolean; seatsFull: boolean; memberLicenseId: number | null },
  acceptErrorCode: string | undefined
): TeamAcceptInviteState {
  if (preview.memberLicenseId !== null) {
    return 'alreadyMember';
  }
  if (!preview.emailMatches || acceptErrorCode === 'M24_TEAM_EMAIL_MISMATCH') {
    return 'mismatch';
  }
  if (preview.seatsFull || acceptErrorCode === 'M24_LIMIT_SEATS') {
    return 'full';
  }
  return 'ready';
}
